export default __webpack_public_path__ + "static/media/7minfitness@3x.1fcde451.jpg";